import Vue from "vue";

export const EventBus = new Vue();

// Event names constants to avoid typos
export const Events = {
	CONTRACT_UNSAVED_CHANGES: "contract-unsaved-changes",
	SYNC_OFFLINE_CHANGES: "sync-offline-changes",
	SHOW_STATUS_BANNER: "show-status-banner",
};
